export var OrgColumnId;
(function (OrgColumnId) {
    OrgColumnId["ORG_NAME"] = "orgName";
    OrgColumnId["GROUPS"] = "groups";
    OrgColumnId["USERS"] = "users";
    OrgColumnId["CREATOR"] = "creator";
    OrgColumnId["CREATED"] = "created";
    OrgColumnId["ACTIONS"] = "actions";
})(OrgColumnId || (OrgColumnId = {}));
export var OrgActionType;
(function (OrgActionType) {
    OrgActionType["EDIT"] = "edit";
    OrgActionType["DELETE"] = "delete";
})(OrgActionType || (OrgActionType = {}));
//# sourceMappingURL=org-management.types.js.map